class StGlobalPreloaderController {
  constructor(sharedService) {
    'ngInject';
    this.name = 'stGlobalPreloader';
    this.loader = sharedService.loader;
  }
}

export default StGlobalPreloaderController;



// WEBPACK FOOTER //
// ./client/app/common/stGlobalPreloader/stGlobalPreloader.controller.js